import { faqData } from '@/mocks/home';

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-10">
          常见问答
        </h2>
        <div className="flex flex-col gap-3">
          {faqData.map((item) => (
            <div
              key={item.id}
              className="bg-background-100 rounded-lg p-5"
            >
              <h3 className="text-sm font-medium text-foreground-900 mb-2 flex items-start gap-2">
                <span className="text-primary-500 flex-shrink-0 mt-0.5">Q</span>
                {item.question}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed flex items-start gap-2">
                <span className="text-accent-500 flex-shrink-0 mt-0.5">A</span>
                {item.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}